module.exports = __webpack_public_path__ + "frontend-assets/img/back-button.108dfe76.png";